import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  copy(event) {
    const token = event.currentTarget.dataset.copyTokenToken
    if (!token) return

    navigator.clipboard?.writeText(token)
    this.showCopiedState(event.currentTarget)
  }

  insert(event) {
    const token = event.currentTarget.dataset.copyTokenToken
    if (!token) return

    const editor = document.querySelector('trix-editor')
    if (editor && editor.editor) {
      editor.editor.insertString(`\n${token}\n`)
      editor.focus()
    } else {
      navigator.clipboard?.writeText(token)
    }

    this.showCopiedState(event.currentTarget, 'Inserted')
  }

  showCopiedState(button, text = 'Copied') {
    const original = button.dataset.copyTokenOriginalText || button.textContent
    button.dataset.copyTokenOriginalText = original
    button.textContent = text
    setTimeout(() => {
      button.textContent = original
    }, 1200)
  }
}
